import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

export const loginMigrations: ThemeApp['appComponents']['loginMigrations'] = {
  redisBackground: {
    color: themeUi.semantic.color.text.neutral100
  }
};
